import angular from 'angular';
import SellerService from '../sellerData/index';

import directive from './secureCredit.directive';

export default angular.module('cars.vdp.creditapplication', [
    SellerService
])

.directive('secureCreditApplication', directive)

.name;
